import { render, staticRenderFns } from "./reporttipslinedeal.vue?vue&type=template&id=63be7bbc"
import script from "./reporttipslinedeal.vue?vue&type=script&lang=js"
export * from "./reporttipslinedeal.vue?vue&type=script&lang=js"
import style0 from "./reporttipslinedeal.vue?vue&type=style&index=0&id=63be7bbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports